<script setup>
import { useCategoryStore } from "@/stores/category";

const categoryStore = useCategoryStore();
</script>

<template>
  <section>
    <div class="flex flex-col gap-6">
      <GameCarousel
        v-for="index in 6"
        v-if="categoryStore.state.categoriesLoading"
        :key="`game-carousel-loader${index}`"
        :is-loading="true"
      />
      <GameCarousel
        v-for="(game, index) in categoryStore.state.categories"
        v-if="!categoryStore.state.categoriesLoading"
        :title="game.name"
        :key="`game-carousel-${index}`"
        :games="game.games"
        :category="{ id: game.id, name: game.name, slug: game.slug }"
      />
    </div>

    <!-- Load aqui!! -->
    <PageLoadersGamesLoaders v-if="false" />
  </section>
</template>
